import React from 'react';
import pic2 from './pic2.jpg';

const ContactSection = () => (
  <section className="section" id="contact">
    <div className="contact-layout">
      <div className="contact-image">
        <img src={pic2} alt="GOS Trans truck" />
        <div className="contact-image-overlay" />
        <span className="contact-image-copy">Your next destination<br />starts here.</span>
      </div>
      <div className="contact-panel">
        <span className="section-kicker">Let's move forward</span>
        <h2>Talk to our<br /><em>dispatch team.</em></h2>
        <p className="contact-intro">Have questions or a load ready to move? We’re here to help.</p>

        <div className="contact-list">
          <a href="tel:3126268383">
            <span className="contact-icon">01</span>
            <span><small>CALL US</small><strong>312 626 8383</strong></span>
            <i>↗</i>
          </a>
          <a href="mailto:dispatch@gostrans.com">
            <span className="contact-icon">02</span>
            <span><small>EMAIL DISPATCH</small><strong>dispatch@gostrans.com</strong></span>
            <i>↗</i>
          </a>
          <div>
            <span className="contact-icon">03</span>
            <span><small>VISIT US</small><strong>5015 Switch Grass Ln<br />Naperville, IL 60564</strong></span>
          </div>
        </div>

        <div className="contact-footer">
          <span>Fax: 312 500 1914</span>
          <span>Available 24/7</span>
        </div>
      </div>
    </div>
  </section>
);

export default ContactSection; 